export default {
  "Choose File": "Datei auswählen",
  "Please paste a URL": "Bitte fügen eine URL ein",
  Loading: "Wird geladen",
  Analyzing: "Analysieren",
  "Try a sample": "Beispiel probieren",
  "Sorry, error occurs when analyzing the URL.": "Bei der Analyse der URL tritt leider ein Fehler auf.",
};
